<template>
  <Icon
    name="analytics"
    :width="18"
    :height="18"
  >
    <path d="M16 0H2C0.900024 0 0 0.900024 0 2V16C0 17.1 0.900024 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.900024 17.1 0 16 0ZM16 16H2V2H16V16ZM6 7H4V14H6V7ZM8 4H10V14H8V4ZM14 10H12V14H14V10Z" />
  </Icon>
</template>

<script>
import Icon from "../Elements/Icon";

export default {
  name: 'Analytics',
  components: { Icon },
};
</script>
